import * as rmd from 'material-ui';
import PropTypes from 'prop-types';
import React from "react";
import _ from "lodash";
import config from "cfg";
import auth from 'dash-front/auth';

class ThemePicker extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            themes: [],
            themeId: props.theme || context.user.defaultTheme
        };
    }
    static defaultProps = {
        sportId: 1
    };

    static contextTypes = {
        user: PropTypes.object.isRequired
    };

    componentDidMount() {
        this.loadThemes();
    }

    loadThemes() {
        let {themeId} = this.state;
        const {user} = this.context;

        return fetch(`${config.dash.api.host}/api/themes?access_token=${auth.getAccessToken()}`)
            .then(response => response.json())
            .then(themes => {
                let theme = themes.find(t => t.id == themeId);

                if (!theme) theme = _.first(themes);

                this.setState({
                    themes,
                    themeId: theme && theme.id
                })
            }).catch(e => {
                console.error(e);
            });
    }

    handleThemeChange = (e, key, payload) => {
        this.props.onChange('theme', payload);
        this.setState({themeId: payload});
    };

    renderOption(option) {
        return (
            <rmd.MenuItem
                key={option.value}
                value={option.value}
                primaryText={option.text}
            />
        );
    }

    render() {
        let {themes, themeId} = this.state;
        themeId = themeId || (themes.find(t => t.isDefault) || {}).id;
        const themesOptions = themes.filter(t => !t.isHidden).map(t => ({text: t.name, value: t.id }));
        return (
            <div>
                {!_.isEmpty(themesOptions) && (
                    <rmd.SelectField
                        style={{width: '100%'}}
                        floatingLabelText="Theme"
                        value={themeId}
                        onChange={this.handleThemeChange}>
                        {themesOptions.map(this.renderOption)}
                    </rmd.SelectField>
                )}
            </div>

        );
    }
}

export default ThemePicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/ThemePicker.js
 **/